// extracted by mini-css-extract-plugin
module.exports = {"player":"styles_player__1wCnB","watch":"styles_watch__2jf0P","isOpenMobile":"styles_isOpenMobile__3iGQl","playerBox":"styles_playerBox__2SYfy","iframe":"styles_iframe__2sHd8"};